import { SvgIconProps } from "../types";

export const SvgIcon = ({
  src,
  width,
  height,
  bgcolor,
  padding,
  boxShadow,
}: SvgIconProps) => (
  <div
    style={{
      display: "inline-block",
      backgroundColor: bgcolor,
      borderRadius: "8px",
      boxShadow,
      width,
      height,
      padding,
    }}
  >
    <img
      src={`/img/svg/${src}`}
      alt={src}
      style={{
        width: "100%",
        height: "100%",
        outline: "rgba(255, 255, 255, 0.25) solid 0.5rem",
        borderRadius: "8px",
      }}
    />
  </div>
);
